import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useFloatingSelect } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { setRef } from '../../../utils/react'
import { FloatingSelectDropdown } from '../../Floating'
import { MultiValuedListMoreButton } from '../MultiValuedListMoreButton'

import { MULTI_VALUED_LIST_MORE_DROPDOWN_STYLES } from './MultiValuedListMore.constants'

function MultiValuedListMore({
  Button = MultiValuedListMoreButton,
  buttonProps,
  children,
  className,
  containerRef,
  count,
  disabled,
  dropdownPlacement = FLOATING_ELEMENT_PLACEMENT.bottom,
  dropdownStyles = MULTI_VALUED_LIST_MORE_DROPDOWN_STYLES,
  floatingPortalId,
  size,
  variant,
}) {
  const { context, floatingStyles, getFloatingProps, isOpen, refs, setOpen } =
    useFloatingSelect({
      containerRef,
      dropdownStyles,
      placement: dropdownPlacement,
    })

  function handleClick(event) {
    if (!disabled) {
      stopPropagation(event)

      setOpen(!isOpen)
    }
  }

  function handleSetButtonRef(ref) {
    setRef(refs.setReference, ref)

    if (buttonProps?.ref) {
      setRef(buttonProps.ref, ref)
    }
  }

  return (
    <>
      <Button
        {...buttonProps}
        className={className}
        count={count}
        disabled={disabled}
        isDropdown={!!children}
        isOpen={isOpen}
        ref={handleSetButtonRef}
        size={size}
        variant={variant}
        onClick={handleClick}
      />
      {children ? (
        <FloatingSelectDropdown
          context={context}
          floatingPortalId={floatingPortalId}
          floatingStyles={{
            ...floatingStyles,
            ...dropdownStyles,
          }}
          getFloatingProps={getFloatingProps}
          isOpen={isOpen}
          refs={refs}
        >
          <div onClick={stopPropagation}>{children}</div>
        </FloatingSelectDropdown>
      ) : null}
    </>
  )
}

export default MultiValuedListMore
